// SAFE-WRITE-BEGIN: _CollapsibleCard.tsx
/**
 * VAL-FINALIZE-LAYOUT-1 L2 — collapse a reference card to a one-line header.
 *
 * The expanded state is plain component state: per page view, never saved.
 * A card that does not ask to be collapsible gets `open = true` and its
 * original `CardTitle`, so every other caller renders exactly as before.
 */
import { useId, useState } from 'react'
import { CardTitle } from '@/components/ui/card'

export function useCollapsible(collapsible: boolean) {
  const [expanded, setExpanded] = useState(false)
  const titleId = useId()
  return {
    open: !collapsible || expanded,
    toggle: () => setExpanded(v => !v),
    titleId,
    cardProps: collapsible
      ? { role: 'region' as const, 'aria-labelledby': titleId }
      : {},
  }
}

export function CollapsibleTitle({
  collapsible,
  open,
  titleId,
  onToggle,
  children,
}: {
  collapsible: boolean
  open: boolean
  titleId: string
  onToggle: () => void
  children: React.ReactNode
}) {
  if (!collapsible) return <CardTitle>{children}</CardTitle>
  return (
    <div className="flex items-center justify-between gap-3">
      <CardTitle id={titleId}>{children}</CardTitle>
      <button
        type="button"
        className="text-sm font-medium text-pal-link underline-offset-2 hover:underline"
        aria-expanded={open}
        onClick={onToggle}
      >
        {open ? 'Hide details' : 'Show details'}
      </button>
    </div>
  )
}
// SAFE-WRITE-EOF: _CollapsibleCard.tsx
